<div class="row content-container">
  <div class="col-12 col-sm-12 main-content mynovi mynovi--history">
    <div class="button-bar button-bar--justify hide-lg hide-md visible-sm">
      <a [routerLink]="['/products']">
        <strong>
          <svg class="icon-arrow-left" height="10" viewBox="0 0 6 10" width="6">
            <use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
          </svg>
          <span i18n="Back to products link text@@back.to.products">
            Back to products
          </span>
        </strong>
      </a>
    </div>

    <div class="button-bar button-bar--topright button-bar--mobile-block">
      <a
        [routerLink]="['/my/claims/new']"
        class="button button--green theme-btn-success new-claim--button"
        i18n="Start a new claim@@claims.new.claim.button"
        >New claim
      </a>
    </div>

    <h1
      class="mynovi-title"
      i18n="Navigation claims overview titel@@claims.overview.title"
      >
      Claim overview
    </h1>

    <div class="product-page-bar_top">
      <novi-pagination
        [callingComponent]="this"
        [pageData]="paginationData"
      ></novi-pagination>
    </div>

    <table
      class="mynovi-data-table mynovi-data-table--history claim-overview-table"
      >
      <thead>
        <tr>
          <th i18n="@@claims.date" scope="col">Date of claim</th>
          <th i18n="@@claims.overview.table.article" scope="col">Article</th>
          <th i18n="@@claims.overview.table.claimnumber" scope="col">
            Claim number
          </th>
          <th i18n="@@claims.status" scope="col">Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr class="mynovi-data-table__loading">
          <td colspan="5" i18n="@@loading.text">Loading &hellip;</td>
        </tr>
        @if (noClaims) {
          <tr class="mynovi-data-table__empty">
            <td colspan="5" i18n="@@claims.overview.noresults">
            No claims found
          </td>
          </tr>
        }
        @if (paginationData) {
          @for (
            claim of claims
            | paginate
            : {
            itemsPerPage: paginationData.size,
            currentPage: paginationData.number + 1,
            totalItems: paginationData.totalElements
          }
          ; track
          claim) {
          <tr
            >
            <td class="mynovi-data-table_datelocation">
              {{ claim.creationDate | customDate: "EEEE dd MMMM YYYY" }}
            </td>
            <td class="claim-detail-table_product">
              {{ claim.itemDescription }}
            </td>
            <td class="mynovi-data-table_orderid">
              {{ claim.claimId }}
            </td>
            <td class="mynovi-data-table_status claim-data-table_status">
              <h4 [status]="claim.status" render-claim-status></h4>
            </td>
            <td class="mynovi-data-table_buttons claim-data-table_buttons">
              <a
                [routerLink]="['/my/claims/detail', { claimId: claim.claimId }]"
                class="button button--secondary theme-btn-primary-outline"
                i18n="@@claims.view.detail.button"
                >
                View claim
              </a>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>

  <div class="button-bar button-bar--right button-bar--mobile-block">
    <a
      [routerLink]="['/my/claims/new']"
      class="button button--green theme-btn-success"
      i18n="Start a new claim@@claims.new.claim.button"
      >New claim
      </a>
  </div>
  <div class="product-page-bar">
    <novi-pagination
      [callingComponent]="this"
      [pageData]="paginationData"
    ></novi-pagination>
  </div>
</div>
</div>
